import type {Integer} from 'platform/foundation';

/**
 * Columns of a chart grid. It has two columns from the desktop breakpoint only: on tablet and
 * notebook, a half-width chart would be too narrow, so every card takes the whole row there and
 * the stored layout stays as it is. Edit mode is offered only where the grid has two columns.
 */
export const CHART_GRID_COLUMNS: [
  mobile: Integer,
  tablet: Integer,
  notebook: Integer,
  desktop: Integer,
] = [1, 1, 1, 2];
